/**
 * Seta na borda da tela para quem está fora dela (F63): aliados (cor e número do slot) e o chefe (coroa
 * vermelha). Recebe a posição projetada em NDC (−1 a 1) e se está atrás da câmera; devolve o ponto na
 * borda (em pixels, com margem) e o ângulo da seta, ou `undefined` se está na tela.
 */
export function edgeArrow(ndcX: number, ndcY: number, behind: boolean, width: number, height: number, margin = 28): { x: number; y: number; angle: number } | undefined {
  let x = ndcX;
  let y = ndcY;
  // Atrás da câmera a projeção vira do avesso: a direção é a oposta.
  if (behind) {
    x = -x;
    y = -y;
  }
  const inside = !behind && x >= -1 && x <= 1 && y >= -1 && y <= 1;
  if (inside) return undefined;
  const len = Math.hypot(x, y) || 1;
  const dx = x / len;
  const dy = y / len;
  // Até a borda do retângulo interno (com a margem), na direção do alvo a partir do centro.
  const hw = width / 2 - margin;
  const hh = height / 2 - margin;
  const k = Math.min(hw / Math.max(Math.abs(dx), 1e-6), hh / Math.max(Math.abs(dy), 1e-6));
  return { x: width / 2 + dx * k, y: height / 2 - dy * k, angle: Math.atan2(-dy, dx) };
}
